// this array of delay times in ms is to control how much delay should occur before re-attempting a failed fetch
export const FETCH_DELAY_TIMES: number[] = [
  0, 200, 500, 750, 1000, 2000, 2000, 3000, 3000, 10000, 10000,
]; // this is the amount of delay to apply

export const MAX_RETRIES: number = FETCH_DELAY_TIMES.length;

/**
 * @param attemptIndex The number of attempts made, used for dynamically setting the delay time.
 * @param overrideDelay The fixed delay time to optionally be used.
 */
export async function delayByAttempt(attemptIndex: number, overrideDelay?: number): Promise<void> {
  const delayInMs = overrideDelay || FETCH_DELAY_TIMES[attemptIndex] || 0;

  return new Promise((resolve) => {
    setTimeout(resolve, delayInMs);
  });
}
